import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=7161bc8f&scoped=true"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"
import style0 from "./AddressComponent.vue?vue&type=style&index=0&id=7161bc8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7161bc8f",
  null
  
)

export default component.exports